/* unplugin-vue-components disabled */import { render } from "./Balance.vue.js?vue&type=template&id=8dd4a013!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Balance.vue?vue&type=template&id=8dd4a013"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__